import { msg } from "@lingui/core/macro";
import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { SongDetailPage } from "@/features/domain/components/song-detail-page";
import { useI18n } from "@/providers/i18n-provider";

function SongDetailRoutePage() {
  const { t } = useI18n();
  const params = useParams({ from: "/_app/songs/$songId" });
  return (
    <AuthPlaceholder
      title={t(msg`Song`)}
      description={t(msg`Sign in to see this song and your parts.`)}
    >
      <PageContainer maxWidth="3xl">
        <SongDetailPage songId={params().songId} />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const songDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/songs/$songId",
  component: SongDetailRoutePage,
});
